import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { BookingSheetRow as View } from './BookingSheetRow'

import { fromCityTypeByLabelSelector } from 'reduxModules/selectors/CitySelectors'

const mapStateToProps = createStructuredSelector({
  fromCityTypeByLabel: fromCityTypeByLabelSelector,
})

export const BookingSheetRow = connect(mapStateToProps)(View)


// WEBPACK FOOTER //
// ./src/components/BookingsSheet/components/BookingSheetRow/index.js